import React, { useEffect, useState } from 'react'
import styles from './overview.module.css'
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import moment from 'moment';
import Tooltip from './Tooltip';



function PotentialCostCard({ filterData, setGraphData }) {
    const { startDate, endDate } = filterData
    const { isLoading, error, sendReq: fetchData } = useHttp();


    const [CardData, setCardData] = useState({
        actualEnergyEfficiency: null,
        targetEnergyEfficiency: null,
        potentialCostSaving: null,
    })

    useEffect(() => {
        // Actual Energy Efficiency API call
        fetchData({
            url: API_URL_MAIN + `mileage_sarathi_ace_overview/average_energy_efficiency`,
            body: {
                filterdata: {
                    ...filterData,
                    CITY: filterData.CITY?.map(item => item?.value) || [],
                    DEPO: filterData.DEPO?.map(item => item?.value) || [],
                }
            }
        }, (res) => {
             const efficiencyValues = res?.Average_energy_Efficiency?.values;
    const efficiencyValue = efficiencyValues ? Object.values(efficiencyValues)[0] : null;

            setCardData(prev => ({
                ...prev,
             actualEnergyEfficiency: efficiencyValue ? efficiencyValue.toFixed(2) : null
                // != 0
                // ? res?.Actual_Energy_Efficiency.toFixed(2)
                // : null
            }));
        });

        // National Benchmark API call
        fetchData({
            url: API_URL_MAIN + `mileage_sarathi_ace_overview/national_benchmark`,
            body: {
                filterdata: {
                    ...filterData,
                    CITY: filterData.CITY?.map(item => item?.value) || [],
                    DEPO: filterData.DEPO?.map(item => item?.value) || [],
                }
            }
        }, (res) => {

            setCardData(prev => ({
                ...prev,
                targetEnergyEfficiency: res?.Target_energy_Efficiency?.values?.["50.0"]?.toFixed(2)
                // ? res?.National_Benchmark?.value?.toFixed(2)
                // : null
            }));
        });

        // Potential Cost Saving API call
        fetchData({
            url: API_URL_MAIN + `mileage_sarathi_ace_overview/potential_cost_saving`,
            body: {
                filterdata: {
                    ...filterData,
                    CITY: filterData.CITY?.map(item => item?.value) || [],
                    DEPO: filterData.DEPO?.map(item => item?.value) || [],
                }
            }
        }, (res) => {
            setCardData(prev => ({
                ...prev,
                potentialCostSaving: res?.potential_cost_saving?.toFixed(2)
                // ? res?.potential_cost_saving?.toFixed(2)
                // : null
            }));
        });

    }, [filterData]);


    useEffect(() => {
        setGraphData(prev => ({ ...prev, potentialDetailsSummary: CardData }))
    }, [CardData])

    return (
        <div className={`p-3 ${styles.cost_savings_tab}`}>
            <div style={{ flex: 1 }}>
                <div className={`r2c1 ${styles.potential_cost_savings}`}>
                    Your potential cost saving - {moment(startDate).format("MMMM YYYY")}
                </div>
                <div className={`r2c1text ${styles.potential_cost_savingstext}`}>
                    Current energy efficiency for your fleet is <b>{CardData?.actualEnergyEfficiency != null ? CardData?.actualEnergyEfficiency + " " : " ... "}</b>
                    against the Target Energy Efficiency of <b>{CardData?.targetEnergyEfficiency != null ? CardData?.targetEnergyEfficiency + ". " : " ... "}</b>
                    This can have potential cost saving of <b>{CardData?.potentialCostSaving != null ? CardData?.potentialCostSaving + ". " : " ... "}</b>
                </div>
            </div>
            <div className="d-flex" style={{ flex: 1 }}>
                <div
                    className={`text-center p-2 me-2 ${styles.fuel_efficiency_tab}`}
                >
                    <div className={`h4 ${styles.fuel_efficiency_tabtext}`}> {CardData?.actualEnergyEfficiency != null ? CardData?.actualEnergyEfficiency : "--"}</div>
                    <div>Actual Energy Efficiency</div>
                </div>
                <div
                    className={`text-center p-2 me-2 ${styles.fuel_efficiency_tab}`}
                >
                    <div className={`h4 ${styles.fuel_efficiency_tabtext}`}>{CardData?.targetEnergyEfficiency != null ? CardData?.targetEnergyEfficiency : "--"}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span> Target Energy Efficiency</span>
                        <span><Tooltip text="The weighted average of benchmark energy efficiency for all the vehicles present in your fleet.">
                            <i
                                className="fas fa-info-circle ms-2"
                                style={{
                                    color: '#358696',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    border: '1px solid #358696',
                                    borderRadius: '50%',
                                    padding: '2px',
                                    marginLeft: '5px'
                                }}
                            ></i>
                        </Tooltip></span>
                    </div>
                </div>
                <div
                    className="text-center p-2"
                    style={{
                        backgroundColor: 'white',
                        border: '1px solid #358696',
                        borderRadius: '5px',
                        width: '100%'
                    }}
                >
                    <div className={`h4 ${styles.fuel_efficiency_tabtext}`}>{CardData?.potentialCostSaving != null ? CardData?.potentialCostSaving : "--"}</div>
                    <div>Potential Cost Saving</div>
                    {/* <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Cost of energy per unit"
                        />
                        <span className="input-group-text">
                            <i className="fas fa-pencil-alt"></i>
                        </span>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default PotentialCostCard
